import { isUndefined } from 'lodash/lang';

import { isLogAvailableForReviewCycle } from '../components/pages/patient-source/Patients/Logs/LogsPageServices';
import { ROLE_PRINCIPAL_INVESTIGATOR, ROLE_SYSTEM_ADMINISTRATOR } from '../constants/userRoles';

import { userHasRole } from './auth';

export function filtrateByInvestigatorFieldIfNeed(elements, formDefinition) {
  const isUserPi = userHasRole(ROLE_PRINCIPAL_INVESTIGATOR);
  const isUserSa = userHasRole(ROLE_SYSTEM_ADMINISTRATOR);
  if (
    !isUserPi &&
    !isUserSa &&
    !isUndefined(formDefinition) &&
    isInvestigatorFieldAvailable(formDefinition.domainCode)
  ) {
    return elements.filter(
      element =>
        element.investigatorField === undefined ||
        element.investigatorField === null ||
        element.investigatorField === false
    );
  } else {
    return elements;
  }
}

export function checkOnInvestigatorFieldIfNeeded(element, domainCode) {
  const isPi = userHasRole(ROLE_PRINCIPAL_INVESTIGATOR);
  const isAdmin = userHasRole(ROLE_SYSTEM_ADMINISTRATOR);
  if (!isPi && !isAdmin && isInvestigatorFieldAvailable(domainCode)) {
    return (
      element.investigatorField === undefined ||
      element.investigatorField === null ||
      element.investigatorField === false
    );
  }
  return true;
}

export function isNotNewReviewableLogType(rowId, domainCode, elementType) {
  return rowId && rowId !== 'newRow' && isReviewableLogType(domainCode, elementType);
}

export function isReviewableLogType(domainCode, elementIcon) {
  return isLogAvailableForReviewCycle(domainCode) && elementIcon === 'Logs';
}

export function isAdverseEventLog(domainCode, elementIcon) {
  return domainCode === 'AE' && elementIcon === 'Logs';
}

export function isInvestigatorFieldAvailable(domainCode) {
  return !['EPS', 'EPSTP', 'EDO', 'ECR'].includes(domainCode);
}
